const AlertMethod = {
	Notification: {
		key: 'notification',
		labelId: 'x_notification',
	},
	Email: {
		key: 'email',
		labelId: 'immediate_email',
	},
	Text: {
		key: 'text',
		labelId: 'immediate_text',
	},
};

export default AlertMethod;
